import * as React from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import Hero from "../../components/hero"
import LinkButton from "../../components/link-button"
import Container from "../../components/container"
import RecentList from "../../components/recent-list"
import ArticleCard from "../../components/article-card"

const ThanksPage = ({ data, location}) => {
  const resourceposts = data.resource.nodes
  const seminarposts = data.seminar.nodes
  
  return (
    <Layout location={location} hasCta={false}>
      <Seo
        title="セミナーのお申し込みありがとうございます"
        description="CDP「INTEGRAL-CORE」のセミナーのお申し込み完了ページです。"
      />
      <Hero type="secondary">
        <div className="lg:w-9/12 lg:m-auto pt-10 lg:pt-32 pb-20 lg:pb-28 text-center">
          <h1 className="font-bold text-2xl lg:text-4xl mb-4 lg:mb-5">
            お申し込みありがとうございました
          </h1>
          <p className="text-xs lg:text-base text-textGray-100 leading-relaxed lg:leading-relaxed mb-12">
            お申し込み内容について、ご登録いただいたメールアドレスへ送信しました。
            <br />
            2〜3営業日後もメールが届かない場合、システムの不具合あるいはご登録いただいたメールアドレスに誤りがある可能性がございます。
            <br />
            お手数ですが再度お申し込みをお願いいたします。
          </p>
          <LinkButton text="セミナー・動画一覧に戻る" url="/seminar/?filter=accepting" type="primary" />
        </div>
      </Hero>

      <div className="py-12 lg:py-24 bg-blue-50">
        <Container>
          <div className="lg:grid lg:grid-cols-2 lg:gap-10">
            <section className="mb-10 lg:mb-0">
              <div className="flex items-center justify-between mb-4 lg:mb-9">
                <h2 className="text-blue-950 text-lg lg:text-2xl font-bold">
                  資料
                </h2>
                <LinkButton type="normal" text="一覧を見る" url="/resource/" />
              </div>
              {resourceposts.length === 0 ? (
                <p className="text-center">資料がありません</p>
              ) : (
                <div className="flex flex-col">
                  {resourceposts.map(post => {
                    return (
                      <div className="mb-3 lg:mb-7 rounded-xl shadow-lg overflow-hidden hover:shadow-xl mb-4 lg:mb-0 bg-white">
                        <Link
                          to={`${data.site.siteMetadata.siteUrl}/resource${post.fields.slug}`}
                        >
                          <ArticleCard
                            key={post.fields.slug}
                            title={post.frontmatter.title}
                            cover={post.frontmatter.cover}
                           />                
                        </Link>
                      </div>
                    )
                  })}
                </div>
              )}
            </section>
            <section className="mb-10 lg:mb-0">
              <div className="flex items-center justify-between mb-4 lg:mb-9">
                <h2 className="text-blue-950 text-lg lg:text-2xl font-bold">
                  セミナー・動画
                </h2>
                <LinkButton type="normal" text="一覧を見る" url="/seminar/?filter=accepting" />
              </div>
              {seminarposts.length === 0 ? (
                <p className="text-center">セミナーがありません</p>
              ) : (
                <div className="flex flex-col">
                  {seminarposts.map(post => {
                    return (
                      <div className="mb-3 lg:mb-7 rounded-xl shadow-lg overflow-hidden hover:shadow-xl mb-4 lg:mb-0 bg-white">
                        <Link
                          to={`${data.site.siteMetadata.siteUrl}/seminar${post.fields.slug}`}
                        >                    
                        <ArticleCard
                          key={post.fields.slug}
                          title={post.frontmatter.title}
                          cover={post.frontmatter.cover}
                          date={post.frontmatter.date}
                        />
                        </Link>
                      </div>
                    )
                  })}
                </div>
              )}
            </section>
          </div>
        </Container>
      </div>

      <section className="py-12 lg:py-24 bg-blue-50">
        <Container>
          <div className="lg:mx-auto">
            <div className="flex items-center justify-between mb-4 lg:mb-9">
              <h2 className="text-blue-950 text-lg lg:text-2xl font-bold">
                ブログ
              </h2>
              <LinkButton
                isExternal={true}
                type="normal"
                text="一覧を見る"
                url="https://www.ever-rise.co.jp/dx-blog/tag/cdp"
                target="_blank"
              />
            </div>
          <RecentList />
          </div>
        </Container>
      </section>
    </Layout>
  )
}

export default ThanksPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    seminar: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fields: { collection: { eq: "seminar" } } }
      limit: 3
    ) {
      nodes {
        frontmatter {
          date(formatString: "YYYY.MM.DD")
          title
          cover {
            childImageSharp {
              gatsbyImageData(width: 464)
            }
          }
        }
        fields {
          slug
        }
      }
    }
    resource: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fields: { collection: { eq: "resource" } } }
      limit: 3
    ) {
      nodes {
        frontmatter {
          date(formatString: "YYYY.MM.DD")
          title
          cover {
            childImageSharp {
              gatsbyImageData(width: 464)
            }
          }
        }
        fields {
          slug
        }
      }
    }
  }
`
